// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M5.5 4L1.5 8L5.5 12M10.5 4L14.5 8L10.5 12'];
